<div class="d-flex flex-column flex-root app-root" id="au_app_root">
    <div class="app-page flex-column flex-column-fluid" id="au_app_page">
     
      <app-header></app-header>
      <div class="app-wrapper flex-column flex-row-fluid" id="au_app_wrapper">
        <div class="app-main flex-column flex-row-fluid" id="au_app_main">
          <div class="d-flex flex-column flex-column-fluid">
            <div id="au_app_content" class="app-content flex-column-fluid pt-2 pb-0">
              <div id="au_app_content_container" class="app-container container-xxl px-0">
                <div class="dashboard-landing-page d-flex bdr-5">
                  <div class="col-xl-3 ps-0">
                    <a routerLink="/system-admin-dashboard/company" draggable="false" routerLinkActive="router-link-active" class="card-overlay">
                      <div class="card active" dir="ltr">
                      <div class="card-body d-flex flex-row rounded py-3">
                        <div class="d-flex">
                          <div class="text-center"><img src="assets/media/misc/company-lg.png" class="w-40px" alt="" draggable="false"></div>
                          <h3 class="d-flex fw-semibold text-gray-800 text-center lh-lg align-items-center px-3 m-0"> Company</h3>
                        </div>
                      </div>
                    </div>
                      </a>
                  </div>
                  <div class="col-xl-3 ps-4">
                    <a routerLink="/system-admin-dashboard/branch" draggable="false" routerLinkActive="router-link-active" class="card-overlay">
                      <div class="card" dir="ltr">
                      <div class="card-body d-flex flex-row rounded py-3">
                        <div class="d-flex">
                          <div class="text-center"><img src="assets/media/misc/branch-lg.png" class="w-40px" alt="" draggable="false"></div>
                          <h3 class="d-flex fw-semibold text-gray-800 text-center lh-lg align-items-center px-3 m-0"> Branch</h3>
                        </div>
                      </div>
                    </div>
                        </a>
                  </div>
                  <div class="col-xl-3 ps-4">
                    <a routerLink="/system-admin-dashboard/user" draggable="false"routerLinkActive="router-link-active" class="card-overlay">
                    <div class="card" dir="ltr">
                      <div class="card-body d-flex flex-row rounded py-3">
                        <div class="d-flex">
                          <div class="text-center"><img src="assets/media/misc/user-lg.png" class="w-40px" alt="" draggable="false"></div>
                          <h3 class="d-flex fw-semibold text-gray-800 text-center lh-lg align-items-center px-3 m-0"> User</h3>
                        </div>
                      </div>
                    </div>
                      </a>
                  </div>
                  <div class="col-xl-3 ps-4">
                      <a routerLink="/system-admin-dashboard/system-settings" draggable="false" routerLinkActive="router-link-active" class="card-overlay">
                    <div class="card" dir="ltr">
                      <div class="card-body d-flex flex-row rounded py-3">
                        <div class="d-flex">
                          <div class="text-center"><img src="assets/media/misc/system-settings-lg.png" class="w-40px" alt="" draggable="false"></div>
                          <h3 class="d-flex fw-semibold text-gray-800 text-center lh-lg align-items-center px-3 m-0"> System Settings</h3>
                        </div>
                      </div>
                    </div>
                      </a>
                  </div>
                </div>
                <router-outlet></router-outlet>
               
              </div>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
      </div>
    </div>
  </div>